import React from 'react';
import { fetchGlobal } from '../api/axios';
import './SearchBar.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setBusquedaGlobalResultados } from '../actions/busquedaGlobalActions';


// Adaptación para usar useNavigate en class component
function SearchBarWrapper(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return <SearchBar {...props} navigate={navigate} dispatch={dispatch} />;
}

class SearchBar extends React.Component {
    state = {
        value: '',
        loading: false,
        showTooltip: false
    };
    inputRef = React.createRef();

    handleInputChange = (e) => {
        this.setState({ value: e.target.value });
    };

    componentDidMount() {
        if (this.props.listenClear) {
            window.addEventListener('clearSearchInput', this.handleClearInput);
        }
    }

    componentWillUnmount() {
        if (this.props.listenClear) {
            window.removeEventListener('clearSearchInput', this.handleClearInput);
        }
    }

    handleClearInput = () => {
        this.setState({ value: '' }, () => {
            if (this.inputRef.current) {
                this.inputRef.current.value = '';
                this.inputRef.current.focus();
            }
        });
    }

    handleSearchInputKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleBuscar();
        }
    }

    handleBuscar = () => {
        const { value } = this.state;
        const { idSeller, navigate, dispatch } = this.props;
        if (!value.trim() || value.trim().length < 3) {
            this.setState({ showTooltip: true });
            setTimeout(() => {
                this.setState({ showTooltip: false });
            }, 2000);
            return;
        }
        this.setState({ loading: true });
        // Navega primero mostrando el spinner
        if (navigate) {
            navigate('/BusquedaGlobalResultados', { state: { loadingGlobal: true } });
        }
        fetchGlobal(value, idSeller)
            .then(res => {
                if (dispatch) {
                    dispatch(setBusquedaGlobalResultados(res));
                }
                if (navigate) {
                    // Actualiza la página con los resultados
                    navigate('/BusquedaGlobalResultados', { state: { resultados: res, loadingGlobal: false } });
                }
                if (this.props.onSearch) {
                    this.props.onSearch(res);
                }
            })
            .catch(err => {
                console.error('Error búsqueda global:', err);
                const errorPayload = { tieneError: true, publicaciones: [], ordenes: [] };
                if (dispatch) {
                    dispatch(setBusquedaGlobalResultados(errorPayload));
                }
                if (navigate) {
                    navigate('/BusquedaGlobalResultados', {
                        state: { resultados: errorPayload, loadingGlobal: false }
                    });
                }
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    render() {
        return (
            <div className="d-flex align-items-center ms-2 position-relative" style={{ width: '100%' }}>
                <input
                    ref={this.inputRef}
                    type="text"
                    className="form-control searchbar-input"
                    placeholder="Ingrese orden, publicación o Sku "
                    onKeyDown={this.handleSearchInputKeyDown}
                    onChange={this.handleInputChange}
                    value={this.state.value}
                    disabled={this.state.loading}
                    required
                    minLength={3}
                    title="Debe ingresar algún tipo de dato"
                    onInvalid={e => e.target.setCustomValidity('Debe ingresar algún tipo de dato')}
                    onInput={e => e.target.setCustomValidity('')}
                    autoComplete="off"
                />
                <span className="searchbar-icon-wrapper" onClick={this.handleBuscar}>
                    <i className="fas fa-search searchbar-icon" />
                </span>
                {this.state.showTooltip && (
                    <div style={{ position: 'absolute', top: '110%', left: '0', zIndex: 10 }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: '#fff',
                            border: '1px solid #212529',
                            color: '#212529',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                            padding: '8px 16px',
                            fontSize: '1rem',
                            fontWeight: 400,
                            minWidth: '280px',
                            whiteSpace: 'nowrap'
                        }}>
                            <span style={{ marginRight: '12px', display: 'flex', alignItems: 'center' }}>
                                <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14', fontSize: '1.2rem' }}></i>
                            </span>
                            <span>Debe ingresar algún tipo de dato</span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}



export default SearchBarWrapper;
